import { Grid, LinearProgress } from '@material-ui/core';
import {  CompanyOverviewCard } from './CompanyDetailsTable';
import { ScoreCard } from './ScoreCard';
import { CompanyFactorContributionTable } from './CompanyFactorContributionTable';
import { BadgeApiItem, CompanyReputation, FactorMeta } from '@pages/company-reputation-score/types';
import { VtrSearchBar } from './VtrSearchBar';


interface Props {
  company: CompanyReputation | null;
  factors: Record<string, FactorMeta>;
  badges:BadgeApiItem[];
 // score: number | null;
  computedScore: number;
  overrideScore: number | null; 
  displayScore: number;
  loading: boolean;
  onFetch: (vtrId: string) => void;
}

export const CompanyReputationTab: React.FC<Props> = ({
  company,
  factors,
  badges,
  computedScore,
  overrideScore,
  displayScore,
  loading,
  onFetch,
}) => {
  
  return (
    <>
      <VtrSearchBar onFetch={onFetch} loading={loading} />
      <br/><br/>
  {(loading) &&
       <LinearProgress />
    }
      {company && displayScore !== null && (
        <Grid container spacing={3} style={{ marginTop: 8 }}>
          <Grid item xs={12} md={4}>
            <ScoreCard company={company} computedScore={computedScore} overrideScore={overrideScore} displayScore={displayScore} badges={badges} />
          </Grid>

          <Grid item xs={12} md={8}>
            <CompanyOverviewCard company={company} />
          </Grid>

          <Grid item xs={12}>
            <CompanyFactorContributionTable
              contributions={company?.factor_contributions}
              factors={factors}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};
